<template>
  <v-app>
    <v-container>
      <v-layout row wrap>
        <v-flex lg12 md12 sm12 xs12>
          <div class="mb-3 mt-3">
            <h2>Pagos parciales</h2>
          </div>
          <div>
            <span
              ><router-link
                :to="{ path: '/mis-eventos' }"
                title="Ver todos mis eventos"
                ><u>Volver a Mis Eventos</u></router-link
              ></span
            ><span> > </span><span>Pagos parciales</span>
          </div>
          <div class="mt-3 mb-4"></div>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>  
      <!-- Detalle del Cliente -->
      <h3>Detalle del Cliente</h3>
      <v-card class="pa-4 mb-4">
        <v-row>
          <v-col cols="12" sm="6">
            <strong>Nombre Cliente:</strong> {{ venta_pago_parcial.venta.nombre + ' ' + venta_pago_parcial.venta.apellidos }}
          </v-col>
          <v-col cols="12" sm="6">
            <strong>Identificación Cliente:</strong> {{ formatoMoneda(venta_pago_parcial.venta.identificacion) }}
          </v-col>
          <v-col cols="12" sm="6">
            <strong>Teléfono Cliente:</strong> {{ venta_pago_parcial.venta.telefono }}
          </v-col>
          <v-col cols="12" sm="6">
            <strong>Dirección Cliente:</strong> {{ venta_pago_parcial.venta.direccion }}
          </v-col>
          <v-col cols="12" sm="6">
            <strong>Correo Electrónico Cliente:</strong> {{ venta_pago_parcial.venta.email }}
          </v-col>           
          <v-col cols="12" sm="6">
            <strong>Venta Número:</strong> {{ venta_pago_parcial.venta.id }}
          </v-col>
          <v-col cols="12" sm="6">
            <strong>Forma de pago:</strong> {{ venta_pago_parcial.venta.forma_pago }}
          </v-col>          
          <v-col cols="12" sm="6">
            <strong>Fecha:</strong> {{ venta_pago_parcial.venta.fecha }}
          </v-col>
          <v-col cols="12" sm="12">
            <strong>Nombre Evento:</strong> {{ venta_pago_parcial.venta.evento_nombre }}
          </v-col>
        </v-row>
      </v-card>
      <!-- Detalle de la Venta -->
      <h3>Detalle de la Venta</h3>
      <v-card class="pa-4 mb-4">
        <v-row>
          <v-col cols="12" sm="6">
            <strong>Total de la venta: </strong> {{ formatoMoneda(venta_pago_parcial.venta.total) | currency }}
          </v-col>
          <v-col cols="12" sm="6">
            <strong>Primer pago: </strong> {{ formatoMoneda(venta_pago_parcial.primer_pago) | currency }}
          </v-col>
          <v-col cols="12" sm="6">
            <strong>Total abonos: </strong> {{ venta_pago_parcial.total_abonos == 0 ? 'No hay abonos realizados.' : formatoMoneda(venta_pago_parcial.total_abonos) | currency }}
          </v-col>
          <v-col cols="12" sm="6">
            <strong>Total pagado: </strong> {{ formatoMoneda(venta_pago_parcial.total_pagado) | currency }}
          </v-col>
          <v-col cols="12" sm="6">            
            <strong>Falta por pagar: </strong>             
            {{ formatoMoneda(venta_pago_parcial.restante_por_pagar == 0 ? '0' : venta_pago_parcial.restante_por_pagar ) | currency }}
            <br>
            <v-chip
              color="orange lighten-2"
              text-color="white"
              small              
              class="ma-2"
              v-if="venta_pago_parcial.venta.active == 4"
            >
              Pendiente de pago
            </v-chip>

            <v-chip
              color="green"
              text-color="white"
              small
              class="ma-2"
              v-else-if="venta_pago_parcial.venta.active == 1"
            >
              Pagado
            </v-chip>
          </v-col>
          <v-col cols="12" sm="6">
            <strong>Venta realizada por: </strong> {{ venta_pago_parcial.venta.email_usuario }}
          </v-col>
        </v-row>
      </v-card>
            
      <!-- Lista de abonos -->
      <h3>Abonos realizados</h3>      
      <v-card class="pa-4 mb-4" v-if="venta_pago_parcial.abonos.length">
        <v-simple-table>
          <thead>
            <tr>
              <th>#</th>
              <th>Total</th>
              <th>Monto Efectivo</th>
              <th>Monto Tarjeta</th>
              <th>Forma Pago</th>
              <th>Voucher</th>
              <th>Fecha</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(abono, index) in venta_pago_parcial.abonos" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ formatoMoneda(Number(abono.monto_efectivo) + Number(abono.monto_tarjeta)) }}</td>
              <td>{{ formatoMoneda(Number(abono.monto_efectivo)) }}</td>
              <td>{{ formatoMoneda(Number(abono.monto_tarjeta)) }}</td>
              <td>{{ abono.forma_pago}}</td>
              <td>{{ abono.code_voucher}}</td>
              <td>{{ abono.created_at }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
      <div v-else>
        <p>No se han registrado abonos.</p>
      </div>  
      <!-- Botón para realizar nuevo abono -->
      <v-btn
        color="primary"
        large
        class="sm-4"        
        v-show="venta_pago_parcial.venta.total != venta_pago_parcial.total_pagado"
        @click="mostrarFormulario = !mostrarFormulario"
      >
        {{ mostrarFormulario ? 'Cancelar' : 'Realizar nuevo abono' }}
      </v-btn>  
      <v-divider></v-divider> 
      <v-expand-transition>
        <div v-show="mostrarFormulario" class="mt-4">
          <v-card elevation="2" class="pa-4">            
            <v-form ref="formAbono" v-model="valido">
              <v-select
                v-model="nuevoAbono.forma_pago"
                :items="['efectivo', 'tarjeta', 'mixto']"
                label="Forma de pago"
                required
              ></v-select>

              <v-text-field
                v-if="nuevoAbono.forma_pago === 'efectivo' || nuevoAbono.forma_pago === 'mixto'"
                v-model="nuevoAbono.monto_efectivo"
                label="Monto en efectivo"
                :formatter="formatMoneda"
                type="number"
                min="0"
              ></v-text-field>

              <v-text-field
                v-if="nuevoAbono.forma_pago === 'tarjeta' || nuevoAbono.forma_pago === 'mixto'"
                v-model="nuevoAbono.monto_tarjeta"
                label="Monto con tarjeta"
                :formatter="formatMoneda"
                type="number"
                min="0"
              ></v-text-field>

              <v-text-field
                v-model="nuevoAbono.code_voucher"
                label="Código de voucher (opcional)"
              ></v-text-field>

              <v-alert
                v-if="errorAbono"
                type="error"
                outlined
                dense
                class="mt-2"
              >
                El monto del abono excede el saldo pendiente de {{ formatoMoneda(venta_pago_parcial.restante_por_pagar) }}.
              </v-alert>

               <v-alert
                v-if="errorAbonoMontoMin"
                type="error"
                outlined
                dense
                class="mt-2"
              >
                El valor a abonar debe ser mayor a cero 
              </v-alert>

              <v-btn color="success" class="mt-3" @click="guardarAbono">
                Guardar Abono
              </v-btn>
            </v-form>
          </v-card>
        </div>
      </v-expand-transition>
    </v-container>
  </v-app>
</template>
<script>
import moment from "moment";
moment.locale("es");

import axios from 'axios';
import { configApi } from '../../api/configApi';
import { headers } from '../../api/headers';

export default {
  data() {
    return {
      venta_pago_parcial: [],
      loading: false,
      mostrarFormulario: false,
      errorAbono: false,
      errorAbonoMontoMin: false,
      valido: true,
      nuevoAbono: {
        forma_pago: '',
        monto_efectivo: 0,
        monto_tarjeta: 0,
        code_voucher: '',
        id_venta: null,
      },
    };
  },
  async beforeCreate() {
    document.title = "Pagos parciales - TicketShop";
    setTimeout(function () {
      self.show_select = true;
    }, 250);
  },
  computed: {
    tipoIdentificaciones() {
      return this.$store.getters["user/listTipoIdentificaciones"];
    },
    restantePorPagar() {
      return (this.venta_pago_parcial && this.venta_pago_parcial.restante_por_pagar) || 0;
    },
    totalNuevoAbono() {
      const efectivo = Number(this.nuevoAbono.monto_efectivo || 0);
      const tarjeta = Number(this.nuevoAbono.monto_tarjeta || 0);
      return efectivo + tarjeta;
    }
  },
  mounted() {
    this.buscarVentasPagosParciales();
    this.nuevoAbono.id_venta = this.$route.params.id_venta
   

  },  
  methods: {    
    formatoMoneda(valor) {
      if (valor != null && valor != "") {
        return new Intl.NumberFormat("es-CO").format(valor);
      } else {
        return "";
      }
    },
    formatFechaHumans(fecha) {
      return moment(fecha).fromNow();
    },
    async buscarVentasPagosParciales() {      
     
      await axios.get(`${configApi.apiUrl}detalle_venta_pago_parcial/`+this.$route.params.id_venta, this.data_busqueda, { headers: headers })
      .then(response => {          
        
        this.venta_pago_parcial = response.data.data;
        
      })

    },
    searchFactura(id) {
      this.$store.dispatch("carrito/searchFactura", id);
    },
    limpiarUser() {
      this.$store.dispatch("carrito/limpiarUserSale", false);
    },
    async guardarAbono() {
      this.errorAbono = false;
      this.errorAbonoMontoMin = false

      // Validar formulario
      if (!this.$refs.formAbono.validate()) return;

      if (this.totalNuevoAbono == 0) {
        this.errorAbonoMontoMin = true
        return;
      }

      // Validar monto no supere lo que falta por pagar
      if (this.totalNuevoAbono > this.restantePorPagar) {
        this.errorAbono = true;
        return;
      }
      

      // Preparar envío
      const payload = {
        ...this.nuevoAbono,
        monto_efectivo: Number(this.nuevoAbono.monto_efectivo || 0),
        monto_tarjeta: Number(this.nuevoAbono.monto_tarjeta || 0),
        id_venta: this.nuevoAbono.id_venta
      };

      console.log('Enviando abono:', payload);

      await axios.post(`${configApi.apiUrl}abonar_venta_pago_parcial`, payload, { headers: headers })
      .then(response => {          
        
        swal("Exito!", "Abono realizado correctamente.", "success");

        this.buscarVentasPagosParciales()
        
      })

      // Reset
      this.mostrarFormulario = false;
      this.nuevoAbono = {
        forma_pago: '',
        monto_efectivo: 0,
        monto_tarjeta: 0,
        code_voucher: '',
        id_venta: payload.id_venta,
      };
    },
  },
};
</script>
<style>
.elevation-1.table-ventas table thead {
  background-color: #cacaca;
}
.elevation-1.table-ventas table thead th {
  color: black;
  font-weight: bold;
}
.elevation-1.table-ventas table tbody td {
  color: black;
  font-size: 16px;
}
</style>